<template>
  <div id="app">
    <NewsHeader v-if="isShowBack" />
    <router-view />
    <NewsFooter />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import NewsHeader from "@/components/TheHeader";
import NewsFooter from "@/components/TheFooter";


export default {
  name: 'App',
  components: {
    NewsHeader,
    NewsFooter
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: '同曦简报',
    // all titles will be injected into this template
    titleTemplate: '%s'
  },
  computed: {
    ...mapGetters(["isLoading", "isShowBack"]),
  }
}
</script>

<style>
html.fp-enabled,
.fp-enabled body {
    margin: 0;
    padding: 0;
    overflow:hidden;

    /*Avoid flicker on slides transitions for mobile phones #336 */
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.fp-section {
    position: relative;
    -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
    -moz-box-sizing: border-box; /* <=28 */
    box-sizing: border-box;
}
.fp-slide {
    float: left;
}
.fp-slide, .fp-slidesContainer {
    height: 100%;
    display: block;
}
.fp-slides {
    z-index:1;
    height: 100%;
    overflow: hidden;
    position: relative;
    -webkit-transition: all 0.3s ease-out; /* Safari<=6 Android<=4.3 */
    transition: all 0.3s ease-out;
}

.fp-tableCell {
    vertical-align: middle;
    width: 100%;
    height: 100%;
}
.fp-slidesContainer {
    float: left;
    position: relative;
}
.fp-controlArrow {
    -webkit-user-select: none; /* webkit (safari, chrome) browsers */
    -moz-user-select: none; /* mozilla browsers */
    -khtml-user-select: none; /* webkit (konqueror) browsers */
    -ms-user-select: none; /* IE10+ */
    position: absolute;
    z-index: 4;
    top: 50%;
    cursor: pointer;
    width: 0;
    height: 0;
    border-style: solid;
    margin-top: -38px;
    -webkit-transform: translate3d(0,0,0);
    -ms-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
}
.fp-controlArrow.fp-prev {
    left: 15px;
    width: 0;
    border-width: 38.5px 34px 38.5px 0;
    border-color: transparent #fff transparent transparent;
}
.fp-controlArrow.fp-next {
    right: 15px;
    border-width: 38.5px 0 38.5px 34px;
    border-color: transparent transparent transparent #fff;
}
.fp-scrollable {
    overflow: hidden;
    position: relative;
}
.fp-scroller{
    overflow: hidden;
}
.iScrollIndicator{
    border: 0 !important;
}
.fp-notransition {
    -webkit-transition: none !important;
    transition: none !important;
}
#fp-nav {
    position: fixed;
    z-index: 100;
    margin-top: -32px;
    top: 50%;
    opacity: 1;
    -webkit-transform: translate3d(0,0,0);
}
#fp-nav.fp-right {
    right: 17px;
}
#fp-nav.fp-left {
    left: 17px;
}
.fp-slidesNav{
    position: absolute;
    z-index: 4;
    opacity: 1;
    -webkit-transform: translate3d(0,0,0);
    -ms-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
    left: 0 !important;
    right: 0;
    margin: 0 auto !important;
}
.fp-slidesNav.fp-bottom {
    bottom: 17px;
}
.fp-slidesNav.fp-top {
    top: 17px;
}
#fp-nav ul,
.fp-slidesNav ul {
  margin: 0;
  padding: 0;
}
#fp-nav ul li,
.fp-slidesNav ul li {
    display: block;
    width: 14px;
    height: 13px;
    margin: 7px;
    position:relative;
}
.fp-slidesNav ul li {
    display: inline-block;
}
#fp-nav ul li a,
.fp-slidesNav ul li a {
    display: block;
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
}
#fp-nav ul li a.active span,
.fp-slidesNav ul li a.active span,
#fp-nav ul li:hover a.active span,
.fp-slidesNav ul li:hover a.active span{
    height: 12px;
    width: 12px;
    margin: -6px 0 0 -6px;
    border-radius: 100%;
 }
#fp-nav ul li a span,
.fp-slidesNav ul li a span {
    border-radius: 50%;
    position: absolute;
    z-index: 1;
    height: 4px;
    width: 4px;
    border: 0;
    background: #333;
    left: 50%;
    top: 50%;
    margin: -2px 0 0 -2px;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
}
#fp-nav ul li:hover a span,
.fp-slidesNav ul li:hover a span{
    width: 10px;
    height: 10px;
    margin: -5px 0px 0px -5px;
}
#fp-nav ul li .fp-tooltip {
    position: absolute;
    top: -2px;
    color: #fff;
    font-size: 14px;
    font-family: arial, helvetica, sans-serif;
    white-space: nowrap;
    max-width: 220px;
    overflow: hidden;
    display: block;
    opacity: 0;
    width: 0;
    cursor: pointer;
}
#fp-nav ul li:hover .fp-tooltip,
#fp-nav.fp-show-active a.active + .fp-tooltip {
    -webkit-transition: opacity 0.2s ease-in;
    transition: opacity 0.2s ease-in;
    width: auto;
    opacity: 1;
}
#fp-nav ul li .fp-tooltip.fp-right {
    right: 20px;
}
#fp-nav ul li .fp-tooltip.fp-left {
    left: 20px;
}
.fp-auto-height.fp-section,
.fp-auto-height .fp-slide,
.fp-auto-height .fp-tableCell{
    height: auto !important;
}

.fp-responsive .fp-auto-height-responsive.fp-section,
.fp-responsive .fp-auto-height-responsive .fp-slide,
.fp-responsive .fp-auto-height-responsive .fp-tableCell {
    height: auto !important;
}

/*Only display content to screen readers*/
.fp-sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
html {
    width:100vw;
    overflow-x:hidden;
}
footer,#app,#app .page{
  max-width: 760px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif,"黑体";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  margin: 0 auto;
}

body,p,h1,h2{
  margin:0;
  padding:0;
}
.container h2{
  font-weight: 600;
  font-size: 20px;
}
.navbar{
  position:fixed;
  z-index: 100;
  top:0;
}
footer{
  border-top:1px solid #f2f2f2;
  background-color:rgba(255,255,255,0.8);
  height: 55px;
  line-height: 14px;
  position:fixed;
  z-index: 100;
  bottom:0;
  width: 100%;
  
}
@media only screen and (max-width: 760px) {
  footer{
    border-top:1px solid #b2b2b2;
    background: #fff;
  }
}
footer ul{
  display:-webkit-flex;
	display:flex;
  -webkit-justify-content:space-around;
	justify-content:space-around;
}

footer a{
  padding-top:12px;
  display: inline-block;
  color:#333;
  text-align: center;
  font-size: 11px;
}
footer a.active{
  color:#aa252e;
}
.fp-tableCell{
  text-align: center;
}
.history{
  position:fixed;
  z-index: 100;
  bottom:65px;
  width: 100%;
  max-width: 760px;
  text-align: right;
}
.history a{
  margin-left:-80px;
  width:70px;
  color:#fff;
  background:#434346;
  border-radius: 0.8em;
  line-height: 1.6em;
  padding:0 10px;
}
.history .iconfont{
  font-size: 1em;
}
.navbar .back{
  position:absolute;
  background:#fff;
  height: 40px;
  width:40px;
  line-height: 40px;
  border-radius: 20px;

  left:.8em;
  top:.6em;
}
.back .iconfont{
    font-size:1.5em;
}
.navbar .container{
  text-align: center;
}
.page{
  margin-bottom: 55px;
}
.news-content{

  line-height: 1.5em;
}
.news-top,.news-body{
  margin:10px 13px;
}
.comment-box{
  padding:10px 13px;
}
.news-top{
  border-bottom: 1px solid #999;
  margin-bottom: 1.5em;
}
.tit{
  color:#333;
  font-size: 1.4em;
  line-height: 1.5em;
  font-weight: 600;
  padding-bottom: 0.3em;
}
.sub-tit{
  font-size:1.2em;
  line-height: 1.2em;
  color:#787878;
  font-weight: 400;
  padding-bottom:0.8em;
}
.meta{
  color:#999;
  margin-bottom:.2em;
}
.author{
  float:right;
}
.news-body{
  color:#333;
  line-height: 2em;
  font-size:1.1em;
}
.news-body img{
  max-width: 100%;
  height:auto;
  margin-left:-2em;
}
.news-body p{
  text-indent: 2em;
  margin-bottom: 1em;
}
.news-body p[style="text-align: center;"]{
  text-indent: 0;
}
.paper-item img{
  max-width: 100%;
}
.paper-item{
  width:50%;
  float:left;
  text-align: center;
  padding:5%;
}
.paper-tit{
  border-top:1px solid #c9c9c9;
  border-bottom:1px solid #c9c9c9;
  color:#646464;
  line-height: 1.4em;
  margin: 0 auto;
  width: 80%;
}
.paper-content::after{
  display: block;
  content: " ";
  clear:both;
}
.post{
  text-align: center;
  padding:1.5em;
}
.post,.right-post{
  color:#5b6a91;
}
.right-post{
  float: right;

}
.top-comment{
  margin:.5em 0;
  color:#888;
}
.comment-box{
  background:#f2f2f2
}

.fixed{
  position: fixed;
  text-align: center;
  top:50%;
  width: 100%;
  
}
.tips{
  margin-top:-50px;
  display: inline-block;
  background:#000;
  color:#fff;
  filter:alpha(Opacity=50);-moz-opacity:0.5;opacity: 0.5;
  line-height: 1.5em;
  padding:5px 10px;
  border-radius: 5px;
}
.loading{
  margin-top:-50px;
}
</style>
